module.exports = __webpack_public_path__ + "img/img_D1.11.555a816a.png";